import { HYBRID_CLASSROOM_V2_FEATURE_FLAG } from "../../shared/featureFlags";
import { useFeatureFlag } from "../lib/FeatureFlags";

export function useHybridClassroom() {
  return useFeatureFlag(HYBRID_CLASSROOM_V2_FEATURE_FLAG);
}
